import { useTranslation } from "react-i18next";
import { getColor } from "../../../../pages/postEditor/seoAnalyzer/helper";

export const LinkingAnalysis = ({ analysis }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Score Bar */}
       <div className="mt-4">
                        <span className="font-semibold mb-3">
                          {analysis.total_score}%
                          </span>
                          </div>
                        
                        <div className="w-full relative p-2 rounded-xl bg-slate-300 mb-5 mt-1">
                          <div
                            className={`bg-${getColor(
                              analysis.total_score
                            )} h-full rounded-xl absolute top-0 left-0`}
                            style={{ width: `${analysis.total_score}%` }}
                          ></div>
                        </div>
      {/* Internal/External Ratio */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t(
            "Number-of-internal-and-external-links ",
            "Number of internal and external links"
          )}{" "}
        </p>
        <p
          className={`${
            analysis?.nb_link?.score == 100
              ? "text-green-500"
              : analysis?.nb_link?.score === 50
              ? "text-yellow-400"
              : analysis?.nb_link?.score == 0 &&
                (analysis?.nb_link?.externalLinks > 0 ||
                  analysis?.nb_link?.internalLinks > 0)
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.nb_link?.score == 100 && (
            <>
              {`${t(
                "You-have-a-good-ratio-of-internal-and-external-links",
                "You have a good ratio of internal and external links"
              )} 
                              (${analysis?.nb_link.internalLinks}:${
                analysis?.nb_link.externalLinks
              }).`}
            </>
          )}
          {analysis?.nb_link?.score == 50 && (
            <>
              {analysis?.nb_link.percentage > 4 && (
                <>
                  {`${
                    analysis?.nb_link.externalLinks == 0
                      ? t(
                          "You_have_good_ratio_but_you_don't_have_external_links_(ratio",
                          "You have good ratio but you don't have external links ratio ("
                        )
                      : t(
                          "You-have-too-many-internal-links-compared-to-your-number-of-external-links-(ratio",
                          "You have too many internal links compared to your number of external links (ratio"
                        )
                  }
                                          ${analysis?.nb_link.internalLinks}:${
                    analysis?.nb_link.externalLinks
                  }).`}
                </>
              )}
              {analysis?.nb_link.percentage < 2 && (
                <>
                  {`${
                    analysis?.nb_link.externalLinks == 0
                      ? t(
                          "You_have_good_ratio_but_you_don't_have_external_links_(ratio",
                          "You have good ratio but you don't have external links ratio ("
                        )
                      : t(
                          "You-have-too-few-internal-links-compared-to-your-number-of-external-links-(ratio",
                          "You have too few internal links compared to your number of external links (ratio"
                        )
                  }
                                          ${analysis?.nb_link.internalLinks}:${
                    analysis?.nb_link.externalLinks
                  }).`}
                </>
              )}
            </>
          )}{" "}
          {analysis?.nb_link?.score == 0 && (
            <>
              {t(
                "Your-content-does-not-contain-any-internal-or-external-links!-Add some!",
                "Your content does not contain any internal or external links! Add some!"
              )}
            </>
          )}{" "}
          {analysis?.nb_link?.score == -1 && (
            <>{t("Please-add-content", "Please add content")}</>
          )}
        </p>
      </div>

      {/* Link Placement */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Link-placement  ", "Link placement")}{" "}
        </p>
        <p
          className={`${
            analysis?.placement == 100 &&
            (analysis?.nb_link?.externalLinks > 0 ||
              analysis?.nb_link?.internalLinks > 0)
              ? "text-green-500"
              : analysis?.placement === 50 &&
                (analysis?.nb_link?.externalLinks > 0 ||
                  analysis?.nb_link?.internalLinks > 0)
              ? "text-yellow-400"
              : analysis?.placement == 0 &&
                (analysis?.nb_link?.externalLinks > 0 ||
                  analysis?.nb_link?.internalLinks > 0)
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.placement === 100 && (
            <>
              {analysis?.nb_link?.externalLinks > 0 ||
              analysis?.nb_link?.internalLinks > 0 ? (
                <>
                  {t(
                    "Your-links-are-evenly-distributed-in-your-content.That’s-perfect!",
                    "Your links are evenly distributed in your content. That’s perfect!"
                  )}
                </>
              ) : (
                <>{t("no_link_found", "No link found")}</>
              )}
            </>
          )}
          {analysis?.placement == 50 && (
            <>
              {t(
                "You-are-not-completely-evenly-distributed-in-your-content.It’s-okay-but-you-could-do-better!",
                "You are not completely evenly distributed in your content. It’s okay but you could do better!"
              )}
            </>
          )}{" "}
          {analysis?.placement == 0 && (
            <>
              {t(
                "Your-links-are-not-evenly-distributed-in-your-content!-It-would-be-ideal-to-equilibrate-that!",
                "Your links are not evenly distributed in your content! It would be ideal to equilibrate that!"
              )}
            </>
          )}{" "}
          {analysis?.placement == -1 && (
            <>{t("Please-add-content", "Please add content")}</>
          )}
        </p>
      </div>
    </>
  );
};
